import React from 'react';

export interface IGeneralDataContext {
  isFullWidthLayout?: boolean;
  instance: string;
  instanceId: string;
  host?: any;
}

export const GeneralDataContext = React.createContext<IGeneralDataContext>({
  isFullWidthLayout: false,
  instanceId: null,
  instance: null,
  host: null,
});

export const GeneralDataContextConsumer = GeneralDataContext.Consumer;
